import BuildScheduleButtons from "../schoolAdminPortal/Seasons/BuildScheduleButtons";
import { ScheduleTableAction } from "../schoolAdminPortal/Seasons/ScheduleTableAction";

export const seasonTableColumns = [
  {
    field: "week",
    headerName: "Week",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 100,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
    renderCell: (params) => (
      <div className="d-flex-align-cent height-70 w-100">
        <p className="link-blue text-width-auto mg-auto">
          {params.row.seasonWeek.title}
        </p>
      </div>
    ),
  },
  {
    field: "opponentName",
    headerName: "Opponent",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 180,
    sortable: false,
    cellClassName: "custom-cell",
    renderCell: (params) => (
      <div className="d-flex-align-cent height-70 w-100">
        <p className=" text-width-auto mg-auto">
          {params.row.opponent.schoolName}
        </p>
      </div>
    ),
  },
  {
    field: "location",
    headerName: "Location",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
  },
  {
    field: "eventDate",
    headerName: "Date",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 130,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
  },
  {
    field: "uiEventTimeConverted",
    headerName: "Time",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 100,
    sortable: false,
    headerClassName: "table-header bold",
    align: "center",
    headerAlign: "center",
    cellClassName: "custom-cell",
  },
  {
    field: "eventType",
    headerName: "Event Type",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    sortable: false,
    headerClassName: "table-header bold",
    align: "center",
    headerAlign: "center",
    cellClassName: "custom-cell",
  },
  {
    field: "signUpDate",
    headerName: "Action",
    flex: 1,
    minWidth: 180,
    headerClassName: "table-header bold",
    align: "center",
    headerAlign: "center",
    sortable: false,
    renderHeader: () => (
      <div className="build-schedule-button-header">
        <BuildScheduleButtons />
      </div>
    ),
    renderCell: (params) => <ScheduleTableAction row={params.row} />,
  },
];
